import {Component} from 'react'
import {Route, Switch, Redirect} from 'react-router-dom'

import LoginForm from './components/LoginForm'
import Home from './components/Home'
import Products from './components/Products'
import ProductItemDetails from './components/ProductItemDetails'
import Cart from './components/Cart'
import NotFound from './components/NotFound'
import ProtectedRoute from './components/ProtectedRoute'
import CartContext from './context/CartContext'

import './App.css'

class App extends Component {
  state = {
    cartList: [],
  }

  //   TODO: Add your code for remove all cart items, increment cart item quantity, decrement cart item quantity, remove cart item

  addCartItem = product => {
    const {cartList} = this.state
    const isitemThere = cartList.filter(each => each.id === product.id)
    if (isitemThere.length === 0) {
      this.setState(prevState => ({cartList: [...prevState.cartList, product]}))
    } else {
      const newList = cartList.map(each => {
        if (each.id === product.id) {
          const quant = each.quantity + 1
          return {...each, quantity: quant}
        }
        return each
      })
      this.setState({cartList: newList})
    }

    //   TODO: Update the code here to implement addCartItem
  }

  onIncrementQuantity = id => {
    const {cartList} = this.state
    const newList = cartList.map(each => {
      if (each.id === id) {
        const quant = each.quantity + 1
        return {...each, quantity: quant}
      }
      return each
    })
    this.setState({cartList: newList})
  }

  onDecrementQuantity = id => {
    const {cartList} = this.state
    const newList = cartList.map(each => {
      if (each.id === id) {
        if (each.quantity === 1) {
          return {}
        }
        const quant = each.quantity - 1
        return {...each, quantity: quant}
      }
      return each
    })
    const newList2 = newList.filter(each => each.id !== undefined)
    this.setState({cartList: newList2})
  }

  removeCartItem = id => {
    const {cartList} = this.state
    const newList = cartList.filter(each => each.id !== id)
    this.setState({cartList: newList})
  }

  removeAllCartItems = () => {
    this.setState({cartList: []})
  }

  render() {
    const {cartList} = this.state

    return (
      <CartContext.Provider
        value={{
          cartList,
          addCartItem: this.addCartItem,
          removeCartItem: this.removeCartItem,
          incrementCartItemQuantity: this.onIncrementQuantity,
          decrementCartItemQuantity: this.onDecrementQuantity,
          removeAllCartItems: this.removeAllCartItems,
        }}
      >
        <Switch>
          <Route exact path="/login" component={LoginForm} />
          <ProtectedRoute exact path="/" component={Home} />
          <ProtectedRoute exact path="/products" component={Products} />
          <ProtectedRoute
            exact
            path="/products/:id"
            component={ProductItemDetails}
          />
          <ProtectedRoute exact path="/cart" component={Cart} />
          <Route path="/not-found" component={NotFound} />
          <Redirect to="not-found" />
        </Switch>
      </CartContext.Provider>
    )
  }
}

export default App
